import {
  EcovadisCurrentStageProgressSteps,
  EcovadisSharingProgressSteps,
  getCurrentStageMessage,
  getEvDataScopeChangeFieldValue,
  getSharingMessage,
  isEcovadisCurrentStageProgressStepActive,
  isEcovadisCurrentStageProgressStepDone,
  isEcovadisSharingProgressStepDone,
  isEvEvaluationInProgress,
} from 'services/common/EcovadisUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import EcovadisScopeChangePopper from '../EcovadisScopeChangePopper';
import EcovadisStopEvaluationButton from '../EcovadisScoresDisplay/EcovadisStopEvaluationButton';
import { useCallback, useContext } from 'react';
import { PrivilegeEnum, RoleBasedAccessControlContext } from 'services/common/RolesUtils';
import { Context } from 'states/Store';
import EcovadisProgressSteps from './EcovadisProgressSteps';

const EcovadisProgress = ({ evData, onRiskChange = () => { } }) => {
  const { classes } = useStyles();
  const [state,] = useContext(Context);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const isEvaluationButtonDisabled = useCallback(() => {
    return (
      !state.thirdparty?.onboarded ||
      !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_ECOVADIS_SOURCE)
    );
  }, [state.thirdparty, hasAnyOfPrivileges]);

  const renderProgress = (evData) => {
    if (isEvEvaluationInProgress(evData)) {
      return (
        <EcovadisProgressSteps
          evData={evData}
          progressSteps={Object.values(EcovadisCurrentStageProgressSteps)}
          isActiveHandler={isEcovadisCurrentStageProgressStepActive}
          isDoneHandler={isEcovadisCurrentStageProgressStepDone}
          additionalMessage={getCurrentStageMessage(
            getEvDataScopeChangeFieldValue(evData, 'current_stage_code'),
            evData?.supplier_contact_email
          )}
        />
      )
    } else {
      return (
        <EcovadisProgressSteps
          evData={evData}
          progressSteps={Object.values(EcovadisSharingProgressSteps)}
          isActiveHandler={isEcovadisCurrentStageProgressStepActive}
          isDoneHandler={isEcovadisSharingProgressStepDone}
          additionalMessage={getSharingMessage(getEvDataScopeChangeFieldValue(evData, 'sharing_status_code'))}
        />
      )
    }
  }

  return (
    <>
      <div className={classes.progressWrapper}>
        <div className={classes.progressStopEvaluation}>
          <EcovadisStopEvaluationButton disabled={isEvaluationButtonDisabled()} onRiskChange={onRiskChange} />
        </div>
        {renderProgress(evData)}
        {evData?.scope_change && <EcovadisScopeChangePopper evData={evData} />}
      </div>
    </>
  );
};

export default EcovadisProgress;
